
import Vue from 'vue'
import Router from 'vue-router'

const Saved = () => import(/* webpackChunkName: "Saved" */ '../views/Saved')
const SavedList = () => import(/* webpackChunkName: "SavedList" */ '../views/SavedList')

// We should import store in bottom of components, because route using component and we need use store for auth
import store from '@/store'

Vue.use(Router)

const savedRouter = [
    {
      path: '/saved',
      name: 'saved',
      component: Saved,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/saved-list',
      name: 'savedlist',
      component: SavedList,
      meta: { requiresAuth: true },
    },
]

export default savedRouter;
